var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLockIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.177,
    height: 18.488,
    viewBox: "0 0 16.177 18.488",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-unlock-alt",
    "data-name": "Icon awesome-unlock-alt",
    d: "M14.444,9.244H5.489V5.521a2.6,2.6,0,1,1,5.2-.032v.578a.865.865,0,0,0,.867.867h1.156a.865.865,0,0,0,.867-.867V5.489A5.489,5.489,0,1,0,2.6,5.543v3.7H1.733A1.734,1.734,0,0,0,0,10.977v5.778a1.734,1.734,0,0,0,1.733,1.733H14.444a1.734,1.734,0,0,0,1.733-1.733V10.977A1.734,1.734,0,0,0,14.444,9.244ZM9.533,14.733a1.444,1.444,0,0,1-2.889,0V13a1.444,1.444,0,0,1,2.889,0Z",
    fill: "#f69e1e"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockIcon);
export default __webpack_public_path__ + "static/media/LockIcon.a68766286d3a319f035e90a2727e08f1.svg";
export { ForwardRef as ReactComponent };